import { memo } from 'react';
import { useLocalization } from '../../Contexts/Localization';
import { GMDialog, ComponentProps as ModalProps } from './Dialog';


interface ComponentProps extends Omit<ModalProps, 'buttons' | 'onClose' | 'noCloseOnBackdropClick'> {
    /**
     * Callback when 'Yes' button clicked
     */
    onYes: () => void;
    /**
     * Label for 'Yes' button. Default 'Yes'
     */
    yesText?: string;
    /**
     * Callback when 'No' button clicked
     */
    onNo: () => void;
    /**
     * Label for 'No' button. Default 'No'
     */
    noText?: string;
}

/**
 * Yes/No button dialog. User choice is required to close the dialog
 */
export const YesNoDialog: React.FC<ComponentProps> = memo(({ onYes, onNo, yesText, noText, ...modalProps }) => {
    const Localization = useLocalization();

    return (
        <GMDialog
            {...modalProps}
            buttons={[
                { children: noText ? noText : Localization.No,
                    onClick: onNo,
                    buttonType: 'secondary_button' },
                { children: yesText ? yesText : Localization.Yes,
                    onClick: onYes,
                    buttonType: 'primary_button' },
            ]}
        />
    );
});